(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ColorPickerModalService', colorPickerModalService);

    function colorPickerModalService($mdDialog) {
        function showPickerDialog(title, colorMode) {
            return $mdDialog.show({
                controller: function ($scope, $mdDialog, $timeout, title, colorMode) {
                    $scope.resolution = 72;
                    $scope.modalTitle = title || 'Pick a color';
                    $scope.currentColor = null;
                    $scope.pickerColorMode = colorMode || 'rgb';
                    $scope.pickerCtrlMethods = {};

                    $scope.toRgbaString = function (hex, alpha) {
                        const converter = new Colors();
                        const rgb = converter.convertColor(hex.replace('#', ''), 'HEX2RGB');
                        return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
                    };

                    $scope.pickerColorChange = function (colors) {
                        $scope.currentColor = colors;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    };

                    $scope.pickerReady = function (colors) {
                        $scope.pickerColorChange(colors);
                        $scope.pickerCtrlMethods.openInContainer($('.color-picker-dialog #pickerContainer').get(0));
                    };

                    $scope.setColor = function () {
                        $mdDialog.hide($scope.currentColor);
                    };

                    $scope.$on('$destroy', () => {
                        $scope.pickerCtrlMethods.destroy();
                    });
                },
                locals: {
                    title: title,
                    colorMode: colorMode
                },
                template: require('./colorPicker.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: false
            });
        }

        return {
            showPickerDialog: showPickerDialog
        };
    }
})();
